<ng-container *ngIf="!!orders">
  <table class="table table-compact tabletop small" *ngIf="orders.length > 0">
    <thead>
    <tr>
      <th class="left">Auftrag</th>
      <th class="left">Lieferant</th>
      <th class="left">Position</th>
      <th class="left">Bezeichnung</th>
      <th class="currency">Summe (netto)</th>
      <th class="right">Anzahl</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let order of orders">
      <td class="left" [routerLink]="['/order/details', order.project_number, order.orderid]">{{ order.project_number }}.0002.{{ order.orderid }}</td>
      <td class="left">{{ order.company_name }}</td>
      <td class="left">{{ order.position }}<span *ngIf="(order?.part ?? 0) > 0">.{{ order.part }}</span> </td>
      <td class="left">{{ order.name }}</td>
      <td class="currency"><b>{{ order.budget | currency: "EUR":'code':'1.2-2':'de' }}</b></td>
      <td class="right">{{ order.number_of_pieces }}</td>
    </tr>
    </tbody>
  </table>
</ng-container>
